import { render } from "./LootCratesListModal.vue?vue&type=template&id=c3c3616c"
import script from "./LootCratesListModal.vue?vue&type=script&lang=js"
export * from "./LootCratesListModal.vue?vue&type=script&lang=js"

import "./LootCratesListModal.vue?vue&type=style&index=0&id=c3c3616c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__